import React, { useState, useEffect, Fragment } from "react";
import { Label, Button } from "reactstrap";
import { CircularProgress } from "../../UI/CircularProgress/CircularProgress";
import { Col, Row } from "../../../components/UI/Customstrap/Customstrap";
import GenericButton from "../../../components/UI/Button/Button";
import confirmIcon from "../../../../public/svg/ButtonIcons/right-arrow.svg";
import downloadIcon from "../../../../public/svg/ButtonIcons/download.svg";
import { Icons } from "../../../components/UI/Icon/Icon";
import { getLegalContracts, setLegalContract } from "../../../services/api/person";
import style from "./ContractOnboarding.scss";
import { HeaderOnboarding } from "../HeaderOnboarding/HeaderOnboarding";
import { showToast } from "../../../utils/helper";
import { InvestorProfileOnboarding } from "../InvestorProfileOnboarding/InvestorProfileOnboarding";
import MediaQuery from "react-responsive";

export const ContractOnboarding = ({ toggleMobileSidebar, confirmContract, confirmInvestmentProfile }) => {
  const [legalContract, setActualLegalContract] = useState({});
  const [contractLoading, setContractLoading] = useState(true);
  const [checked, setChecked] = useState(false);
  const [showAccounts, setShowAccounts] = useState(false);
  const [isAlreadyAccepted, setIsAlreadyAccepted] = useState(false);

  useEffect(() => {
    setContractLoading(() => true);
    getLegalContracts()
      .then(({ response }) => {
        if (response.result.Code !== 200) {
          showToast("Error obteniendo nuevos contratos del servidor", true);
        } else {
          setIsAlreadyAccepted(response.isAlreadyAccepted);
          if (response.LegalContractSDT.LegalContractAttachmentName) {
            setActualLegalContract({
              ...response.LegalContractSDT,
              LegalContractAttachmentBlob: response.blobfile,
            });
          }
        }
      })
      .catch((err) => {
        console.error(err);
        showToast("Error obteniendo nuevos contratos del servidor", true);
      })
      .finally(() => {
        setContractLoading(() => false);
      });
  }, []);

  const downloadFile = () => {
    var a = document.createElement("A");
    a.href = `data:application/octet-stream;base64,${legalContract.LegalContractAttachmentBlob}`;
    a.download = `${legalContract.LegalContractAttachmentName}.${legalContract.LegalContractAttachmentExtension}`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  };

  const handleChangeCheckbox = () => {
    setChecked((prevState) => !prevState);
  };

  const handleChangePage = () => {
    {
      checked
        ? toggleShowAccounts()
        : showToast("Debe aceptar los términos y condiciones del contrato", true);
    }
  };

  const handleChangePageAlreadyAccepted = () => {
    confirmContract();
    setShowAccounts((stateAccounts) => !stateAccounts);
  };

  const toggleShowAccounts = () => {
    setLegalContract({ LegalContractId: legalContract.LegalContractId })
      .then(({ response }) => {
        if (response.result.Code === 200) {
          showToast("Contrato confirmado correctamente");
          confirmContract();
          setShowAccounts((stateAccounts) => !stateAccounts);
        }
      })
      .catch((err) => {
        showToast("Error confirmando el contrato", true);
        console.error(err);
      });
  };

  if (isAlreadyAccepted) {
    return (
      <div className={style.contract}>
        <HeaderOnboarding title="Contrato legal" toggleMobileSidebar={toggleMobileSidebar} />
        <Row className={style.headerTitle}>
          <Label>Contrato legal</Label>
          <MediaQuery maxWidth={576}>
            <div className={style.divider}></div>
          </MediaQuery>
        </Row>
        <Row className={style.dataRow}>
          <Col className={style.colContract}>
            <div>
              <div className={style.text}>Usted ya ha firmado el último contrato vigente.</div>
              <div className={style.buttonContainer}>
                <GenericButton
                  label={"Continuar"}
                  rounded
                  padding={"8px 46px"}
                  primary
                  right
                  handleClick={handleChangePageAlreadyAccepted}
                  iconSvg={[{ width: "16px", item: confirmIcon }]}
                ></GenericButton>
              </div>
            </div>
          </Col>
          {showAccounts && (
            <InvestorProfileOnboarding
              toggleMobileSidebar={toggleMobileSidebar}
              confirmInvestmentProfile={confirmInvestmentProfile}
            />
          )}
        </Row>
      </div>
    );
  }

  return (
    <div className={style.contract}>
      <HeaderOnboarding title="Aceptá el Contrato legal" toggleMobileSidebar={toggleMobileSidebar} />
      <Row className={style.headerTitle}>
        <Label>Aceptá el Contrato legal</Label>
        <MediaQuery maxWidth={576}>
          <div className={style.divider}></div>
        </MediaQuery>
      </Row>
      <Row className={style.dataRow}>
        <Col className={style.colContract}>
          <div>
            <div className={style.text}>Revisá el Contrato legal y el Anexo I en el siguiente documento:</div>
            <div className={style.contractContainer}>
              <div className={style.boxContract}>
                <Icons.FileIcon size="md" />
                {contractLoading ? (
                  <CircularProgress />
                ) : (
                  <Fragment>
                    <div>
                      <p className={style.contractPdf}>
                        {legalContract && legalContract.LegalContractAttachmentName
                          ? `${legalContract.LegalContractAttachmentName}.${legalContract.LegalContractAttachmentExtension}`
                          : "No hay contratos disponibles."}
                      </p>
                    </div>
                  </Fragment>
                )}
              </div>
              <div className={style.pdfButtons}>
                <div className={style.downloadPdf}>
                  <GenericButton
                    handleClick={downloadFile}
                    right
                    rounded
                    width={"200px"}
                    marginLeft={"0px"}
                    label={"Descargar PDF"}
                    padding={"10px 22px"}
                    iconSvg={[{ width: "24px", item: downloadIcon }]}
                  ></GenericButton>
                </div>
              </div>
            </div>
            <div className={style.chekboxContract}>
              <span onClick={handleChangeCheckbox}>
                {checked ? (
                  <Icons.CheckboxCheckedIcon className={style.icon} />
                ) : (
                  <Icons.CheckboxUncheckedIcon className={style.icon} />
                )}
              </span>
              <p className={style.textAcceptContract}>
                He leído, comprendido y acepto los términos y condiciones del Contrato legal y del Anexo I de
                ueno Casa de Bolsa.
              </p>
            </div>
          </div>
          <div>
            <div className={style.buttonContainer}>
              <GenericButton
                label={"Confirmar"}
                rounded
                padding={"8px 46px"}
                primary
                right
                handleClick={handleChangePage}
                iconSvg={[{ width: "16px", item: confirmIcon }]}
              ></GenericButton>
            </div>
          </div>
        </Col>
      </Row>
      {showAccounts && (
        <InvestorProfileOnboarding
          toggleMobileSidebar={toggleMobileSidebar}
          confirmInvestmentProfile={confirmInvestmentProfile}
        />
      )}
    </div>
  );
};
